import React from 'react';
import { Tag, Button, theme } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { CICLO_ETAPA_UI } from 'assets/data/cicloMeta';

const { useToken } = theme;

const SEV_COLOR = { BAJA: 'green', MEDIA: 'blue', ALTA: 'orange', CRITICA: 'red' };
const ACCION_LABEL = {
  presupuestar: 'Presupuestar',
  generar_odt: 'Generar ODT',
  asignar_odt: 'Asignar técnico',
};

const fmtCLP = (n) =>
  new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    maximumFractionDigits: 0,
  }).format(n || 0);

// Texto de prioridad/estado por etapa (español neutral, no técnico).
function agingText(etapa, row) {
  if (etapa === 'PRESUPUESTADO') return `espera al cliente hace ${row.aging_days} días`;
  if (etapa === 'APROBADO') return `aprobado hace ${row.aging_days} días`;
  if (etapa === 'EN_ODT') return row.sin_asignar ? 'ODT sin técnico asignado' : 'ODT en ejecución';
  if (etapa === 'DETECTADO') return `detectado hace ${row.aging_days} días`;
  return null;
}

function CicloRow({ row, etapa, onAccion, onVerDetalle }) {
  const { token } = useToken();
  const ui = CICLO_ETAPA_UI[etapa] || {};
  const isHallazgo = row.kind === 'hallazgo';
  // La acción se muestra salvo en EN_ODT, donde solo aplica si está sin asignar.
  const mostrarAccion = Boolean(ui.accion) && (etapa !== 'EN_ODT' || row.sin_asignar);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '10px 12px',
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        background: token.colorBgContainer,
      }}
    >
      <div style={{ width: 76, flexShrink: 0 }}>
        {isHallazgo ? (
          <Tag color={SEV_COLOR[row.severidad] || 'default'} style={{ margin: 0 }}>
            {row.severidad || 'S/D'}
          </Tag>
        ) : (
          <span
            style={{
              fontSize: 11,
              color: token.colorTextTertiary,
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            N°{row.id}
          </span>
        )}
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: 13.5,
            fontWeight: 600,
            color: token.colorText,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {row.titulo}
        </div>
        <div style={{ fontSize: 12, color: token.colorTextSecondary }}>
          {row.subtitulo}
          {row.ascensor ? ` · ${row.ascensor}` : ''}
          {row.monto ? ` · ${fmtCLP(row.monto)}` : ''}
        </div>
      </div>

      <div
        style={{
          width: 200,
          flexShrink: 0,
          fontSize: 12,
          color: token.colorTextTertiary,
          textAlign: 'right',
        }}
      >
        {agingText(etapa, row)}
      </div>

      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        {mostrarAccion ? (
          <Button type="primary" size="small" onClick={() => onAccion(row)}>
            {ACCION_LABEL[ui.accion]} <RightOutlined style={{ fontSize: 10 }} />
          </Button>
        ) : null}
        <Button size="small" onClick={() => onVerDetalle(row)}>
          Ver detalle
        </Button>
      </div>
    </div>
  );
}

export default CicloRow;
